module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "one"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../../common/images/one-title.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "share-desc"
  }, [_c('div', [_vm._v("\n      机构投资者中的金融机构需要按照以下准备材料，并将资料图片发送给理财经理\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "share-main"
  }, [_c('div', {
    staticClass: "share-main-title"
  }, [_vm._v("\n      请准备以下材料\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "share-main-content",
    staticStyle: {
      "padding": "35px 20px"
    }
  }, [_c('div', {
    staticClass: "share-content"
  }, [_vm._v("\n        1、营业执照扫描件、组织机构代码证扫描件、税务登记证扫描件（三证合一机构提供营业执照扫描件即可）；\n        "), _c('br'), _vm._v("\n        2、开户许可证扫描件；\n        "), _c('br'), _vm._v("\n        3、开展金融业务相关资格证明；\n        "), _c('br'), _vm._v("\n        4、法定代表人身份证正反面扫描件（或照片）；\n        "), _c('br'), _vm._v("\n        5、经办人身份证正反面扫描件（或照片）；\n        "), _c('br'), _vm._v("\n        6、-产品类投资者还需提供产品成立、备案证明文件；\n        "), _c('br'), _vm._v("\n        7、投资者基本信息表（机构）相关信息；*产品类投资者还需填写投资者信息表（产品）相关信息；\n        "), _c('br'), _vm._v("\n        8、经办人授权函\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "share-download"
  }, [_c('img', {
    attrs: {
      "width": "160px",
      "src": require("../../../common/images/share-download.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#B99558",
      "text-align": "center",
      "font-size": "13px"
    }
  }, [_vm._v("\n    为了顺利完成线上签约，请识别二维码下载APP\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "erweima"
  }, [_c('div', {
    staticClass: "Android"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Android")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../../common/images/erweima.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "IOS"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("IOS")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../../common/images/erweima.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0f28718"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Share/page/six.vue
// module id = 1094
// module chunks = 1